import Functions from './Functions'; //Functionsコンポーネント

const Calendar = () => {
  return (
    <>
      <p id="displayDay">日付</p>
      <input type="date" id="calendar" defaultValue={Functions.getToDay()} />
    </>
  )
}

export default Calendar;